const IconToken = ({ width = 20, height = 20, fill = "#252525", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_7_711)">
        <path
          d="M6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5Z"
          stroke={fill}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5675 7.7775C14.2765 8.04182 14.9074 8.48064 15.4018 9.0534C15.8963 9.62615 16.2383 10.3143 16.3963 11.0543C16.5543 11.7943 16.5232 12.5621 16.3058 13.2869C16.0884 14.0116 15.6918 14.6699 15.1526 15.2007C14.6134 15.7315 13.949 16.1179 13.221 16.3239C12.4929 16.53 11.7247 16.5491 10.9873 16.3796C10.2499 16.2101 9.56709 15.8573 9.00213 15.354C8.43716 14.8507 8.00823 14.213 7.755 13.5"
          stroke={fill}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.25 4.5H6V7.5"
          stroke={fill}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5325 10.41L13.0575 10.9425L10.9425 13.0575"
          stroke={fill}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7_711">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconToken;
